<template>
	<div>
		<div
			class="box-border p-4 border-2 border-gray-300 bg-gray-100 cursor-pointer flex flex-col space-y-4 justify-between h-full"
			@click="openUpload"
		>
			<div class="font-bold">{{ this.repairProof.title }}</div>
			<MetaInfoImage :meta-info-media="this.repairProof" :deletable="false" v-if="checkIfImageContent" />
			<div class="flex justify-center items-center px-4 h-24 pb-4" v-else>
				<img :src="this.repairProof.iconPath" :alt="this.repairProof.title" class="max-h-full" />
			</div>
			<BaseCamera
				v-if="getAuthenticatedUserGroupLevel !== '2'"
				ref="RepairProof.BaseCamera"
				class="flex justify-center items-center"
				:disable-success-message="true"
				:enable-preview="false"
				:allow-upload-in-app-container="false"
				@snapshot="snapshotCam($event)"
				:label="$t('take_picture')"
			></BaseCamera>
		</div>
	</div>
</template>
<script>
import BaseCamera from '@/components/forms/inputs/BaseCamera';
import MetaInfoImage from '@/components/damagecases/forms/MetaInfoImage';
import AppContainerMixin from '@/mixins/AppContainerMixin';

export default {
	name: 'RepairProofCamera',
	components: { BaseCamera, MetaInfoImage },
	mixins: [AppContainerMixin],
	props: {
		getAuthenticatedUserGroupLevel: {},
		repairProof: {},
		isOptionalDamageImage: { default: false },
	},
	data() {
		return {
			imageContentExists: false,
		};
	},
	computed: {
		checkIfImageContent() {
			return this.repairProof.base64Content;
		},
	},
	methods: {
		openUpload() {
			if (window.appcontainer.isiOSAppcontainer) {
				this.$refs['RepairProof.BaseCamera'].openCamera();
			} else {
				this.$refs['RepairProof.BaseCamera'].openUpload();
			}
		},
		snapshotCam(event) {
			this.imageContentExists = true;
			this.repairProof.base64Content = event;
			if (this.isOptionalDamageImage === true) {
				this.repairProof.isOptional = true;
			}
			this.$emit('snapshotCam', { isOptional: this.repairProof.isOptional });
		},
	},
};
</script>
